export const getLocaleDate = (date: string, options:Intl.DateTimeFormatOptions = { year: 'numeric', month: 'numeric', day: 'numeric' }) => {
  const convert = new Date(date);
  return convert.toLocaleDateString('sv', options);
};

export const getLocaleTime = (date: string, options:Intl.DateTimeFormatOptions = { hour: 'numeric', minute: 'numeric' }) => {
  const convert = new Date(date);
  return convert.toLocaleTimeString('sv', options);
};

export const isToday = (dateString: string) => {
  const date = new Date(dateString);
  const now = new Date();
  return date.getDate() === now.getDate() &&
    date.getMonth() === now.getMonth() &&
    date.getFullYear() === now.getFullYear();
};

export const timeAgo = (timeInput: string, longInput?: boolean, textStyle?: Intl.RelativeTimeFormatStyle) => {
  const now: Date = new Date();
  const date = new Date(timeInput);
  const diffInMilliseconds: number = now.getTime() - date.getTime();
  const rtf: Intl.RelativeTimeFormat = new Intl.RelativeTimeFormat('sv', { numeric: 'auto', style: textStyle });

  if (Math.abs(diffInMilliseconds) < 1000) {
    return rtf.format(0, 'second');
  }

  const seconds: number = Math.floor(diffInMilliseconds / 1000);
  if (seconds < 60) {
    return rtf.format(-seconds, 'second');
  }

  const minutes: number = Math.floor(seconds / 60);
  if (minutes < 60) {
    return rtf.format(-minutes, 'minute');
  }

  const hours: number = Math.floor(minutes / 60);
  if (hours < 24) {
    return rtf.format(-hours, 'hour');
  }

  const days: number = Math.floor(hours / 24);
  if (days < 30) {
    const value = rtf.format(-days, 'day');
    if (longInput && days > 0 && days < 7) {
      return `${value}, ${date.toISOString().slice(0, 10)}`;
    } else {
      return value;
    }
  }

  const months: number = Math.floor(days / 30);
  if (months < 12) {
    return rtf.format(-months, 'month');
  }

  const years: number = Math.floor(months / 12);
  return rtf.format(-years, 'year');
};

